import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="relative section tone-testimonials" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-xs tracking-[0.3em] uppercase mb-3" style={{ color: "var(--cs-navy)" }}>Kind words</p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-serif-display text-4xl md:text-5xl leading-tight"
            style={{ color: "var(--cs-navy)" }}
            data-testid="testimonials-heading"
          >
            Testimonials
          </motion.h2>
          <p className="mt-5" style={{ color: "#1B2563" }}>From those who have sat with the cards.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="rounded-3xl p-8 relative transition-colors"
              style={{ background: "rgba(255,255,255,0.85)", border: "1px solid rgba(255,255,255,0.6)", backdropFilter: "blur(10px)", boxShadow: "0 12px 36px rgba(19,26,72,0.18)" }}
              data-testid={`testimonial-card-${i}`}
            >
              <Quote className="w-10 h-10 mb-4" strokeWidth={1.5} style={{ color: "var(--cs-purple)" }} />
              <p className="leading-relaxed mb-6 font-body" style={{ color: "#334155" }}>{t.quote}</p>
              <div className="flex items-center gap-3 pt-4 border-t" style={{ borderColor: "rgba(19,26,72,0.10)" }}>
                <span className="w-8 h-8 rounded-full flex items-center justify-center text-white font-semibold text-sm" style={{ background: "linear-gradient(135deg, var(--cs-purple), var(--cs-rose))" }}>
                  {t.author.charAt(0)}
                </span>
                <p className="font-serif-display text-lg italic" style={{ color: "var(--cs-purple)" }}>— {t.author}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
